// extracted by mini-css-extract-plugin
export var backdropBlur = "_l2-0";
export var contentCard = "_l2-5";
export var frame = "_l2-2";
export var image = "_l2-4";
export var imagePane = "_l2-3";
export var modal = "_l2-1";